import "./Tuyendung.css";
import { Check, FileText, MessageCircle } from 'lucide-react';

const benefits = [
  'Được đào tạo quy trình và kịch bản trước khi nhận cuộc gọi',
  'Không phải tự tìm kiếm khách hàng',
  'Lương khởi điểm 15.000.000đ + thưởng + hoa hồng',
  'Nhận lương chuyển khoản đúng ngày 10 hằng tháng',
];

export default function Apply() {
  return (
    <section id="apply">
      <div className="wrap">
        <div className="apply">
          <div className="apply-info">
            <div className="sec-eyebrow">Ứng tuyển ngay</div>
            <h2>Gọi điện hoặc nhắn tin Zalo cho chúng tôi, tiếp nhận hồ sơ nhanh trong vòng 24 giờ</h2>
            <p>
              Không cần CV, không yêu cầu kinh nghiệm. Bạn có thể nhắn tin qua Zalo hoặc điền biểu mẫu ứng tuyển.
              Bộ phận tuyển dụng sẽ liên hệ trực tiếp để trao đổi công việc.
            </p>

            <ul className="apply-list">
              {benefits.map((item) => <li key={item}><Check />{item}</li>)}
            </ul>

            <div className="apply-actions">
              <a href="https://zalo.me/0773318775" className="apply-btn zalo" target="_blank" rel="noreferrer">
                <MessageCircle /> Nhắn tin qua Zalo
              </a>
              <a href="https://forms.gle/vUrDG86ZUsm3DNgm8" className="apply-btn form" target="_blank" rel="noreferrer">
                <FileText /> Điền form ứng tuyển
              </a>
            </div>

            <div className="apply-contact-note">Bộ phận tuyển dụng sẽ phản hồi sau khi nhận được thông tin ứng tuyển.</div>
          </div>
        </div>
      </div>
    </section>
  );
}